import axios from "../utils/axios";

// Get all sliders
export const getSliders = async (params = {}) => {
    const response = await axios.get('/sliders', { params });
    return response.data;
};

// Get single slider
export const getSlider = async (id) => {
    const response = await axios.get(`/sliders/${id}`);
    return response.data;
};

// Create slider
export const createSlider = async (data) => {
    const response = await axios.post('/sliders', data);
    return response.data;
};

// Update slider
export const updateSlider = async (id, data) => {
    const response = await axios.put(`/sliders/${id}`, data);
    return response.data;
};

// Delete slider (soft delete)
export const deleteSlider = async (id) => {
    const response = await axios.delete(`/sliders/${id}`);
    return response.data;
};

// Force delete slider
export const forceDeleteSlider = async (id) => {
    const response = await axios.delete(`/sliders/${id}/force-delete`);
    return response.data;
};

// Restore slider
export const restoreSlider = async (id) => {
    const response = await axios.post(`/sliders/${id}/restore`);
    return response.data;
};

export const massDestroySliders = async (data) => {
    const response = await axios.delete('/sliders/mass-destroy', { data });
    return response.data;
};

export const massForceDeleteSliders = async (data) => {
    const response = await axios.delete('/sliders/mass-force-delete', { data });
    return response.data;
};

export const massRestoreSliders = async (data) => {
    const response = await axios.post('/sliders/mass-restore', data);
    return response.data;
};